import { CREATE_BUNDLE_SUCCESS, EDIT_BUNDLE_SUCCESS } from '../actions/bundles';
import { showFlashMessage } from '../actions/ui';

const bundles =
  ({ dispatch }) =>
  next =>
  action => {
    switch (action.type) {
      case EDIT_BUNDLE_SUCCESS:
      case CREATE_BUNDLE_SUCCESS:
        dispatch(
          showFlashMessage('Product bundle details updated', {
            type: 'success',
          }),
        );
        break;
      default:
        break;
    }

    return next(action);
  };

export default bundles;
